import React from 'react';
import { Icon } from './Icon.js';
export const IconFlameFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6.492.184c-.282-.245-.701-.245-.983,0-.174.151-4.258,3.733-4.258,7.071,0,2.617,2.131,4.745,4.75,4.745s4.75-2.128,4.75-4.745C10.75,3.917,6.666.334,6.492.184Zm-2.206,8.594c0-.99.995-2.228,1.714-2.963.719.736,1.714,1.973,1.714,2.963,0,.95-.769,1.722-1.714,1.722s-1.714-.772-1.714-1.722Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconFlameFill12.js.map